module.exports = __webpack_public_path__ + "img/tea_logo.5efe0374.png";